export const LATEST_RUN = [
    { label: 'Latest Run', value: 'all' },
]

export const DATE_RANGE = [
    { label: 'Last 7 Days', value: 'all' },
    { label: 'Last 10 Days', value: 'Last 10 Days' },
    { label: 'Last Month', value: 'Last Month' },
    { label: 'Last Year', value: 'Last Year' },
]

export const REPORT_TYPES = [
    { label: 'All Reports', value: 'all' },
    { label: 'Adyen', value: 'Adyen' },
    { label: 'Opera', value: 'Opera' },
    { label: 'Amex', value: 'Amex' },
]

export const FILTER_STATUSES = [
    { label: 'All Statuses', value: 'all' },
    { label: 'Matched', value: 'Matched' },
    { label: 'Likely Matched', value: 'Likely Matched' },
    { label: 'Discrepancy', value: 'Discrepancy' },
]

export const STATUS_RAG = [
    { label: 'RAG', value: 'all' },
    { label: 'RAG & Blue', value: 'include_blue' },
    { label: 'Reconciled (Green)', value: 'green' },
    { label: 'Unreconciled (Red)', value: 'red' },
    { label: 'Potential Match (Amber)', value: 'amber' },
    { label: 'Pending (Blue)', value: 'blue' },
]

export const MISMATCH_REASONS = [
    { label: 'All Reasons', value: 'all' },
    // { label: 'Timing mismatch', value: 'Timing mismatch' },
    // { label: 'Amount mismatch', value: 'Amount mismatch' },
    // { label: 'Missing in POS', value: 'Missing in POS' },
    // { label: 'Missing in PSP', value: 'Missing in PSP' },
    // { label: 'Duplicate in PSP', value: 'Duplicate in PSP' },
    // { label: 'Duplicate in POS', value: 'Duplicate in POS' },
    // { label: 'Refund not linked', value: 'Refund not linked' },
]

export const MISMATCH_REASONS_REVIEW = [
    { label: 'All Reasons', value: 'all' },
    { label: 'Date discrepancy', value: 'Date discrepancy' },
    { label: 'Partial payment', value: 'Partial payment' },
    { label: 'Wrong match', value: 'Wrong match' },
]


export const TRANSACTIONS_TYPE = [
    { label: 'All Transactions', value: 'all' },
    { label: 'Settled', value: 'Settled' },
    { label: 'Sent For Settle', value: 'SentForSettle' },
    { label: 'Refunded', value: 'Refunded' },
    { label: 'Sent For Refund', value: 'SentForRefund' },
]

export const FILES_TYPE = [
    { label: 'All Files', value: 'all' },
]

export const DEPARTMENTS = [
    { label: 'All Departments', value: 'all' },
    // { label: 'Restaurant', value: 'Restaurant' },
    // { label: 'Spa', value: 'Spa' },
    // { label: 'Conference', value: 'Conference' },
    // { label: 'Room Service', value: 'Room Service' },
    // { label: 'Bar', value: 'Bar' },
]

export const MATCH_UNMATCH = [
    { label: 'Match', value: 'match' },
    { label: 'Unmatch', value: 'unmatch' },
]